const focusColor = "#22BF00";

export const customStyles = {
    option: (provided, state, base) => {
        return {
            ...base,
            ...provided,
            display: "flex",
            alignItems: "center",
            color: "#393939",
            fontFamily: "Poppins",
            backgroundColor: "#FFFFFF",
            fontWeight: state.isSelected ? "400" : "400",
            minHeight: "36px",
            "&:hover": {
                backgroundColor: "#FFF8F1",
                color: "#393939",
                fontWeight: "400",
                cursor: "pointer",
            },
        };
    },
    control: (base, state, provided) => ({
        ...provided,
        paddingLeft: "0px",
        fontWeight: "400",
        fontSize: "14px",
        // height:   "36px",
        minHeight: "36px",
        fontFamily: "Poppins",
        ...base,
        boxShadow: state.isFocused ? 0 : 0,
        borderColor: state.isFocused ? focusColor : base.borderColor,
        "&:hover": {
            borderColor: state.isFocused ? focusColor : base.borderColor,
            cursor: "pointer",
        },
    }),
    multiValue: (styles) => {
        return {
            ...styles,
            backgroundColor: "#D8E6FF",
        };
    },
    multiValueRemove: (styles, {data}) => ({
        ...styles,
        backgroundColor: "#D8E6FF",
        color: "#191919",
        "&:hover": {
            backgroundColor: "#D8E6FF",
            color: "#191919",
        },
    }),
    menu: (provided) => {
        return {
            ...provided,
            border: `1px solid ${focusColor}`,
            zIndex: '3'
        };
    },
    singleValue: (provided) => {
        return {
            ...provided,
            marginLeft: "2px",
        };
    },
    indicatorSeparator: (provided) => {
        return {
            ...provided,
            backgroundColor: "none",
        };
    },
    dropdownIndicator: (base, state) => {
        return {
            ...base,
            color: state.isFocused ? "#0bee03" : "#AAAAAA",
        };
    },
    placeholder: (provided) => {
        return {
            ...provided,
            marginLeft: "2px",
            color: "#697D95",
            fontWeight: "400",
        };
    },
    menuList: (base, state) => ({
        ...base,
        maxHeight: '180px',
        zIndex: '3'
    }),
    input: (provided) => ({
        ...provided,
        input: {
            opacity: "1 !important",
        },
    }),
};
